export const firebaseConfig = {
apiKey: "AIzaSyA3gq7ATAScDY7ab7qyAywy9cgFpzq4w1U",authDomain: "pruforce-fc8b8.firebaseapp.com",projectId: "pruforce-fc8b8",storageBucket: "pruforce-fc8b8.appspot.com",messagingSenderId: "618021898898",appId: "1:618021898898:web:d9b69c06c2c8687d18f44b",measurementId: "G-PJBRW5EFP4"
};
